export default "__VITE_ASSET__D4OE8AsI__"